
import AddVehiclesStore from "./AddVehicleStore";
import AddVehiclesContainer from "./AddVehiclesContainer";


export default AddVehiclesStore(AddVehiclesContainer);